import React, { useContext } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const shopLink = {
  rozetka:
    'https://rozetka.com.ua/ua/chesterfield-4823003213620/p371998410/?utm_source=PMUsmsCHE_orgnl_jun',
  cigPoshta:
    'https://cig-poshta.in.ua/chesterfield-original/?utm_source=CDAsmsCHE_orgnl_jun'
};

const HomeScreen = () => {
  const { sendEvent } = useContext(DataLayerEventContext);

  return (
    <div className={styles.container}>
      <div
        className={styles.content}
        style={{
          backgroundImage: `url(${getImageFromS3('images/sms-che-xl/bg.png')})`
        }}
      >
        <div className={styles.headContainer}>
          <img
            className={styles.headLogo}
            src={getImageFromS3('images/sms-che-xl/head-logo.png')}
            alt="head-logo"
          />
          <p className={styles.headLogoTitle}>
            Cкоро
            <br />
            <b>Chesterfield Original 30 XL</b>
          </p>
          <p className={styles.disappearTitle}>зникнуть з полиць ❌</p>
          <p className={styles.butText}>
            Але <b>Chesterfield Original</b> має незмінні характеристики у пачці
            формату 20 сигарет
          </p>
          <img
            className={styles.disappearPack}
            src={getImageFromS3('images/sms-che-xl/disappear-pack.png')}
            alt="disappear-pack"
          />
          <div className={styles.packsCharacteristic}>
            {/*<p className={styles.priceText}><b>145</b> грн*</p>*/}
            <div className={styles.characteristicContainer}>
              <div style={{ padding: '0 45px 0 52px' }}>
                <p>9 мг</p>
                <p>вміст смол</p>
                <p>9 мг</p>
              </div>
              <div>
                <p>0.7 мг</p>
                <p>вміст нікотину</p>
                <p>0.7 мг</p>
              </div>
              <div>
                <p>30 сигарет</p>
                <p>формат</p>
                <p>20 сигарет</p>
              </div>
            </div>
          </div>
          {/*<p className={styles.disclaimerContainer}>*/}
          {/*  *зазначено задекларовану максимальну роздрібну ціну з<br />*/}
          {/*  урахуванням акцизного податку на роздрібний продаж<br />*/}
          {/*  тютюнових виробів станом на січень 2026 року*/}
          {/*</p>*/}
        </div>
        <div className={styles.formatContainer}>
          <img
            className={styles.formatBg}
            src={getImageFromS3('images/sms-che-ks/gold-bg.png')}
            alt="format-bg"
          />
          <p>“Кінг Cайз Cтандарт”</p>
        </div>
        <div className={styles.bottomContainer}>
          <div className={styles.characteristicContainer}>
            <div className={styles.characteristicItem}>
              <img
                src={getImageFromS3('images/sms-che-ks/filter.png')}
                alt="filter"
              />
              <p>Ацетатний фільтр</p>
            </div>
            <div className={styles.characteristicItem}>
              <img
                src={getImageFromS3('images/sms-che-ks/tobacco.png')}
                alt="tobacco"
              />
              <p>Бленд з трьох сортів тютюну</p>
            </div>
          </div>
        </div>
        <div className={styles.buyContainer}>
          <p className={styles.title}>Де купити?</p>
          <p className={styles.description}>
            <b>Chesterfield Original</b> можна знайти
            <br /> у роздрібних точках продажу в<br /> твоєму місті або на
            офіційних
            <br /> онлайн сервісах, зокрема:
          </p>
        </div>
        <div className={styles.buttonContainer}>
          <button
            onClick={() => {
              sendEvent('rozetka');
              window.open(shopLink.rozetka, '_blank');
            }}
          >
            <img
              src={getImageFromS3('images/sms-che-ks/button-bg.png')}
              alt="button-bg"
            />
            <p>Rozetka</p>
          </button>
          <button
            onClick={() => {
              sendEvent('cig-poshta');
              window.open(shopLink.cigPoshta, '_blank');
            }}
          >
            <img
              src={getImageFromS3('images/sms-che-ks/button-bg.png')}
              alt="button-bg"
            />
            <p>Cig-poshta</p>
          </button>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає
        <br />
        серйозні
        <br />
        захворювання та
        <br />
        залежність
        <br />
        Дана інформація про
        <br />
        продукт надається
        <br /> відповідно
        <br /> до статті 15 Закону
        <br /> України «Про захист
        <br />
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) лист, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=che_ks">Відписатися від SMS тут.</a>
      </div>
    </div>
  );
};

export default HomeScreen;
